import React, { Component } from 'react'
import { Form, Input, DatePicker, Button } from 'antd'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
const { RangePicker } = DatePicker;

const FilterContainer=styled.div`
  padding:20px;
`

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = { 

     }
  }
  render() {
    const {t,filterChange,search} = this.props
    return (
      <FilterContainer>
        <Form layout="inline">
          <Form.Item label={t('Username')}>
            <Input allowClear onChange={(e)=>{filterChange('userName',e.target.value)}}></Input>
          </Form.Item>
          <Form.Item label={t('Date')}>
            <RangePicker allowClear onChange={(value)=>{filterChange('time',value)}}></RangePicker>
          </Form.Item>
          <Form.Item>
            <Button onClick={search}>{t('Search')}</Button>
          </Form.Item>
        </Form>
      </FilterContainer>
    )
  }
}

export default withTranslation()(Filter);